import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicRateType({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 17"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.95.2c.92 0 1.67.7 1.74 1.6l.01.15v2.3a.75.75 0 01-1.5.1v-2.4a.25.25 0 00-.2-.24l-.05-.01h-9a.25.25 0 00-.24.2l-.01.05v10c0 .12.08.22.2.24l.05.01H4.5a.75.75 0 01.1 1.5H1.95c-.92 0-1.67-.7-1.74-1.6l-.01-.15v-10C.2 1.03.9.28 1.8.21L1.96.2h9zm-2 3a.75.75 0 01.1 1.5h-5.1a.75.75 0 01-.1-1.5h5.1zM7.2 6.95a.75.75 0 00-.75-.75h-2.6a.75.75 0 00.1 1.5h2.6a.75.75 0 00.65-.75zM12 8.5a1 1 0 110 2 1 1 0 010-2zm3.2-1.52a.75.75 0 00-.67-.68l-3.76-.34a.75.75 0 00-.6.22l-4.49 4.49a.75.75 0 000 1.06l4.1 4.1c.3.3.77.3 1.07 0l4.48-4.49a.75.75 0 00.22-.6l-.34-3.76zM7.28 11.2l3.71-3.71 2.8.25.24 2.79-3.7 3.7-3.05-3.03z"
      />
    </svg>
  );
}

SvgBasicRateType.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicRateType.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicRateType svgRef={ref} {...props} />);
export default ForwardRef;
